import { classNamesFunction } from '@fluentui/react';
import { ThrowOnUndefinedColorContext } from '@m365-admin/customizations';
import { M365Breadcrumb } from '@m365-admin/m365-breadcrumb';
import * as React from 'react';
import { getStepToShow } from '../utilities/index';
import { Wizard } from '../wizard/index';
const { useContext } = React;
const getClassNames = classNamesFunction();
/** Component for Setup Wizard */
export const SetupWizardBase = (props, state) => {
    const [isNarrow, setIsNarrow] = React.useState(state.isNarrow);
    // Get wizard title section
    const _onRenderTitle = (setupWizardProps) => {
        if (setupWizardProps?.breadcrumbProps) {
            return (React.createElement(M365Breadcrumb, { ...setupWizardProps.breadcrumbProps, styles: classNames.subComponentStyles.breadcrumb }));
        }
        if (title) {
            return React.createElement("div", { className: classNames.titleSection }, title);
        }
        return null;
    };
    const { styles, theme, title, wizardProps, breadcrumbProps, onRenderTitle = _onRenderTitle, } = props;
    const context = useContext(ThrowOnUndefinedColorContext);
    const classNames = getClassNames(styles, {
        theme: theme,
        isNarrow: isNarrow,
        isLoading: !!wizardProps.isLoading,
        colorThrowContext: context,
    });
    const stepToShow = getStepToShow(wizardProps);
    // Get wizard action bar
    const onRenderActionBar = (step) => {
        return React.createElement("div", { className: classNames.actionBarSection }, step.footerElement);
    };
    const onIsNarrowChanged = (newNarrowValue) => {
        setIsNarrow(newNarrowValue);
        if (wizardProps?.onIsNarrowChanged) {
            wizardProps.onIsNarrowChanged(newNarrowValue);
        }
    };
    if (title && breadcrumbProps) {
        console.warn('It looks like you have passed in both a title and breadcrumbProps. Title will be overridden by breadcrumbProps. Please choose one or the other.');
    }
    if (breadcrumbProps?.styles) {
        console.warn('It looks like you passed in breadcrumb.styles. These will be overwritten. Please use SetupWizardProps.styles.subComponentStyles.breadcrumb instead.');
    }
    return (React.createElement("div", { className: classNames.wizardContainer },
        onRenderTitle(props, _onRenderTitle),
        React.createElement(Wizard, { ...props.wizardProps, stepToShow: stepToShow, onIsNarrowChanged: onIsNarrowChanged, styles: classNames.subComponentStyles.wizard }),
        onRenderActionBar(stepToShow)));
};
//# sourceMappingURL=setup-wizard.base.js.map